import http from "@/api.js";
import { isEqual } from "lodash";
export default {
    data: () => ({
        sending_in_progress: false,
        choice_out_edit: "",
        choice_out_expressed: null,
        voteapi: "/meetings/vote/",
        votedata: [],
        vote_ready: 0,
        vote_init: false,
        pending_votes: [],
        reload_choice_in: 0,
        vsca_colors: ["#283583", "#68dfa3", "#fc2938", "#00c9e2", "#fdcb00"],
    }),
    watch: {
        //choice_out: { handler: "emit_choice_out", deep: true},
        reload_from_choice_in: { handler: "replace_choice_out", deep: true},
    },
    props: {
        choice_in: { type: Array, },
        reload_from_choice_in: { type: Number, default: 0,},
    },
    computed: {
        choice_out: {
            get(){ return this.choice_out_edit; },
            set(value){
                this.choice_out_edit = value;
                this.$emit("vote-change", { participant: this.participant, resolution: this.resolution.uid, choice_out: value });
            },
        },
        currentVoteReadonly(){  return this.choice_in.find(v => v.resolution == this.resolution.uid); },
        currentVoteDataReadonly(){ return this.currentVoteReadonly?.vote || ""; },
        currentVoteReadableReadonly(){ return this.currentVoteReadonly?.readable || ""; },
        queued_votes(){
            return this.pending_votes.filter(v => {
                let vote = this.votedata.find(e => e.participant == v.participant && e.resolution == v.resolution);
                if (vote?.uid && this.isResolutionAnonymous(v.resolution))
                    return false;
                return this.isVoteChanged(vote, v);
                //let status = vote ? !this.isEqualityVote(vote, v.choice_out) : this.isChoiceOutOk(v.choice_out);
            });
        },
        mergeChoicePending(){
            let choice_in = JSON.parse(JSON.stringify(this.choice_in));
            let pending_votes = JSON.parse(JSON.stringify(this.pending_votes));
            let current_votes = [];
            choice_in.forEach((ci) => {
                let pv = pending_votes.find(({ participant, resolution }) => participant == ci.participant && resolution == ci.resolution);
                if(pv)
                    current_votes.push(pv);
                else
                    current_votes.push(ci);
            });
            pending_votes.forEach(pv => {
                if(!current_votes.find(cv => cv.participant == pv.participant && cv.resolution == pv.resolution)) current_votes.push(pv);
            });
            return current_votes
        },
    },
    methods: {
        isVoteChanged(votedata, pending){
            if (!votedata && !pending.choice_out){
                return false;
            }else if (!pending.choice_out && votedata?.vote){
                return true;
            }else if (!votedata && pending.choice_out){
                return true;
            }else if (typeof pending.choice_out == "string"){
                return this.isVoteStringChanged(votedata, pending);
            }else if (typeof pending.choice_out == "object"){
                if(pending.choice_out.length == 0)
                    return !votedata?.vote_json ? false : true;
                else if (typeof pending.choice_out[0] == "string")
                    return this.isVoteArrayStringChanged(votedata, pending);
                return this.isVoteArrayObjectChanged(votedata, pending);
            }
            return false;
        },
        isVoteStringChanged(votedata, pending){
            return votedata?.vote != pending.choice_out;
        },
        isVoteArrayStringChanged(votedata, pending){
            if(votedata?.vote_json && pending.choice_out){
                const sortedArr1 = votedata?.vote_json.slice().sort();
                const sortedArr2 = pending.choice_out.slice().sort();
                return JSON.stringify(sortedArr1) != JSON.stringify(sortedArr2);
            }
            return true;
        },
        isVoteArrayObjectChanged(votedata, pending){
            return !isEqual(
                votedata.vote_json.map(({...keepAttrs}) => keepAttrs),
                pending.choice_out.map(({...keepAttrs}) => keepAttrs)
            );
        },
        currentPendingVotes(resolution){ return this.mergeChoicePending.filter(v => v.resolution == resolution); },
        currentChoiceIn(pp){ return this.choice_in.find(v => v.participant == pp); },
        active(c){ return (this.choice_out == c); },
        emit_choice_out(){
            if(this.vote_init){
                this.$emit("vote-change", { participant: this.participant, resolution: this.resolution.uid, choice_out: this.choice_out });
            }
        },

        replace_from_choice_in(){ this.replace_choice_out(); },
        replace_choice_out(){
            let choice = this.mergeChoicePending.find(c => c.participant == this.participant && c.resolution == this.resolution.uid);
            this.choice_out_edit = JSON.parse(JSON.stringify(choice?.vote || choice?.choice_out || this.choice_out_edit));
            if(this.resolution.is_anonymous && choice?.uid)
                this.choice_out_expressed = this.choice_out_edit;
        },
        caleol_values(values){
            return values.filter(ch => ch.id).map((ch, idx) => ({
                id: ch.id,
                desc: ch.desc,
                choice: ch.choice || "",
                color: values?.color || this.vsca_colors[(idx % this.vsca_colors.length)],
            }));
        },
        isResolutionAnonymous(uid){
            return this.resolutiondata.find(r => r.uid == uid).is_anonymous;
        },
        voteUrl(group, uid, suffix){
            suffix = suffix || "";
            const url = "/api/"+group+this.voteapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        loadVotes(meeting){
            this.vote_ready = 1;
            const ppuid = this.participant?.uid ? this.participant?.uid + "/" : "";
            http.get(this.voteUrl(this.group, meeting, "my_list_of_votes/" + ppuid)).then(response => {
                this.votedata = response.data;
                this.vote_ready = 2;
            });
        },
        sendMyVotesPromise(group, meeting, votes){
            const ppuid = this.participant?.uid ? this.participant?.uid + "/" : "";
            return http.post(this.voteUrl(group, meeting, "send_my_votes/" + ppuid), votes);
        },
    }
}
